<template>
  <b-modal
      id="edit-shift-modal"
      title="Sửa ca thi"
      size="xl"
      centered
      hide-footer
      v-model="visible"
      @hidden="onCancel"
      @show="setStaffId"
  >
    <ValidationObserver ref="form" v-slot="{ invalid }">
    <el-form label-width="130px" class="pt-3">
      <div class="row">
        <div class="col-lg-6 col-xs-12">
          <div class="mb-3">
            <p>Trung tâm <span class="text-danger">*</span></p>
            <el-input :value="form?.center?.name" disabled/>
          </div>

          <div v-if="isMainExam" class="mb-3">
            <p>Lớp <span class="text-danger">*</span></p>
            <el-input :value="form?.classroom?.name" disabled/>
          </div>

          <div class="mb-3">
            <p>Loại bài thi <span class="text-danger">*</span></p>
            <el-input :value="examTypeName[form?.exam_type]" disabled/>
          </div>

          <div v-if="showExamName" class="mb-3">
            <p>Bài thi</p>
            <el-input :value="null" disabled/>
          </div>

          <div class="mb-3">
            <p>Thời gian thi <span class="text-danger">*</span></p>
            <el-time-picker
                v-if="isMainExam"
                v-model="editExamTime"
                value-format="HH:mm:ss"
                placeholder="Chọn thời gian thi"
                style="width: 100%"
            />
            <el-input v-else :value="form?.exam_time" disabled/>
          </div>

          <div class="mb-3">
            <p>Hình thức thi <span class="text-danger">*</span></p>
            <el-input :value="examFormName[form?.exam_form]" disabled/>
          </div>

          <div class="mb-3">
            <p>Link phòng zoom</p>
            <el-input :value="form?.admin_profile?.link_test" disabled placeholder="Link zoom phòng thi"/>
          </div>
        </div>

        <div class="col-lg-6 col-xs-12">
          <div v-if="isMainExam" class="mb-3">
            <p>Khóa học <span class="text-danger">*</span></p>
            <el-input :value="form?.course?.name" disabled/>
          </div>

          <div class="mb-3">
            <p>Ngày thi <span class="text-danger">*</span></p>
            <el-date-picker
                v-if="isMainExam"
                v-model="editExamDate"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                placeholder="Chọn ngày thi"
                :picker-options="datePickerOptions"
                style="width: 100%"
            />
            <el-input v-else :value="form?.exam_date" disabled/>
          </div>

          <div class="mb-3">
            <p>Sĩ số <span class="text-danger">*</span></p>
            <el-input type="number" :value="form?.registration_count" disabled/>
          </div>
          <div class="mb-3">
            <p>Sĩ số tối đa<span class="text-danger">*</span></p>
            <ValidationProvider
                vid="max_slots"
                name="Sĩ số tối đa"
                :rules="maxSlotsRules"
                mode="eager"
                v-slot="{ errors }"
            >
              <el-input v-model="maxSlots" />
              <div class="fv-plugins-message-container">
                <div class="fv-help-block text-danger">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
<!--          <div class="mb-3">-->
<!--            <p>Sĩ số <span class="text-danger">*</span></p>-->
<!--            <el-input v-model="form.max_slots" type="number" min="1"/>-->
<!--            <p v-if="isMaxSlotsBelowRegistration" class="text-danger mt-1 mb-0">-->
<!--              Sĩ số không được nhỏ hơn số lượng đã đăng ký ({{ form.registration_count }})-->
<!--            </p>-->
<!--          </div>-->
          <div class="mb-3">
            <p>Nhân sự coi thi <span class="text-danger">*</span></p>
            <el-select v-model="staffId" placeholder="Chọn nhân sự coi thi" style="width: 100%" filterable>
              <el-option
                  v-for="staff in staffList"
                  :key="staff.id"
                  :label="`${staff.name} - ${staff.userId + 100000}`"
                  :value="staff.id"
              />
            </el-select>
          </div>

          <div class="mb-3">
            <p>Pass phòng Zoom</p>
            <el-input :value="form.zoom_pass || 'Không có thông tin'" disabled/>
          </div>
          <div class="mb-3">
            <p>Link nhóm zalo</p>
            <el-input :value="form.link_group_zalo || 'Không có thông tin'" disabled/>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row-reverse mt-4">
        <button type="button" class="btn ml-3" style="background-color: #5D04B0; color: white" :disabled="isConfirmDisabled || invalid"
                @click="onConfirm">
          <i v-if="loading" class="el-icon-loading"></i> Xác nhận
        </button>
        <button type="button" class="btn btn-secondary" @click="onCancel">Hủy</button>
      </div>
    </el-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import {EDIT_EXAM_SHIFTS} from "@/core/services/store/marking/admin.module";
import {examScheduleTypes} from "@/common/define";
import {extend} from "vee-validate";
extend('max_slots_valid', {
  params: ['registrationCount'],
  validate(value, {registrationCount}) {
    if (value === null || value === undefined || String(value).trim() === '') {
      return 'Sĩ số tối đa là bắt buộc';
    }
    const str = String(value).trim();
    if (!/^\d+$/.test(str)) {
      return 'Sĩ số tối đa phải là số nguyên dương';
    }
    const num = Number(str);
    if (num < 1) {
      return 'Sĩ số tối đa phải là số nguyên dương';
    }
    const regCount = Number(registrationCount) || 0;
    if (num < regCount) {
      return `Sĩ số tối đa phải lớn hơn hoặc bằng sĩ số hiện tại (${regCount} học viên)`;
    }
    return true;
  },
});

export default {
  name: 'EditExamShiftModal',
  props: {
    visible: Boolean,
    form: Object,
    staffList: Array
  },
  data() {
    return {
      loading: false,
      staffId: null,
      maxSlots: null,
      editExamDate: null,
      editExamTime: null,
      examTypeName: examScheduleTypes.reduce((types, item) => ({...types, [item.id]: item.name}), {}),
      IMentorId: 530,
      examFormName:{
        1:'Online',
        2:'Offline'
      },
      datePickerOptions: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date.getTime() < today.getTime();
        }
      }
    }
  },
  computed: {
    isMainExam() {
      return this.examTypeName[this.form?.exam_type] === 'Thi chính'
    },
    showExamName() {
      return this.examTypeName[this.form?.exam_type] === 'Thi chính' && +this.form.center_id === this.IMentorId
    },
    maxSlotsRules() {
      const registrationCount = Number(this.form?.registration_count) || 0;
      return {
        required: true,
        max_slots_valid: registrationCount,
      };
    },
    isConfirmDisabled() {
      const isMaxSlotsEmpty = this.maxSlots === null || this.maxSlots === undefined || String(this.maxSlots).trim() === '';
      if (this.isMainExam) {
        return !this.staffId || !this.editExamDate || !this.editExamTime || isMaxSlotsEmpty;
      }
      return !this.staffId || isMaxSlotsEmpty;
    },
    // isMaxSlotsBelowRegistration() {
    //   const maxSlots = Number(this.form?.max_slots);
    //   const registrationCount = Number(this.form?.registration_count ?? 0);
    //   if (this.form?.max_slots === '' || this.form?.max_slots == null) {
    //     return false;
    //   }
    //   return maxSlots < registrationCount;
    // }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false)
    },
    async onConfirm() {
      // if (this.isMaxSlotsBelowRegistration) {
      //   this.$message.warning(
      //       `Sĩ số không được nhỏ hơn số lượng đã đăng ký (${this.form.registration_count})`
      //   );
      //   return;
      // }
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      this.loading = true;
      const payload = {
        id: this.form.id,
        admin_profile_id: this.staffId,
        max_slots: Number(this.maxSlots),
        // max_slots: this.form.max_slots
      };

      if (this.isMainExam) {
        payload.exam_date = this.editExamDate;
        payload.exam_time = this.editExamTime;
      }

      this.$store.dispatch(EDIT_EXAM_SHIFTS, payload).then(() => {
        this.$message({
          showClose: true,
          message: 'Đã sửa thành công',
          type: 'success'
        });
        this.$emit('submit')
        this.$emit('update:visible', false)
      }).catch(() => {
        this.$message({
          showClose: true,
          message: 'Đã có lỗi xẩy ra',
          type: 'error'
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    setStaffId() {
      this.staffId = this.form?.admin_profile?.id;
      this.maxSlots = this.form?.max_slots;
      this.editExamDate = this.form?.exam_date || null;
      this.editExamTime = this.form?.exam_time || null;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      });
    }
  }
}
</script>

<style scoped>
.el-input,
.el-select {
  width: 100%;
}
</style>
